import React, { useEffect, useMemo, useState } from "react";
import "./subHeader2d.scss";
import Checkbox from "../checkbox/Checkbox";
import Checkbox1 from "../checkbox/Checkbox1";
import { useDispatch, useSelector } from "react-redux";
import { SET_SERIES_TYPE, SelectSeriesType, SelectSeriesTypeDisableFlag } from "../../../redux/2d-slice/seriesSlice2d";
import moment from "moment";
import { SelectAnnoucements, SelectCurrentGameTime, SelectNextGameTime, SelectUserWallet, SelectLastSaleAmount, SelectLastTicketId } from "../../../redux/2d-slice/gameInfo2dSlice";
import { useNavigate } from "react-router-dom";
import { AuthState } from "../../../context/AuthProvider";
import { SocketState } from "../../../context/SocketProvider";
import { SET_MAIN_LOADER } from "../../../redux/loaderSlice";

import SideTableSeriesCheckbox from "../main-table/component/SideTableSeriesCheckbox";
import Marquee from "react-fast-marquee";
import TimerControl from './TimerControl'

function SubHeader() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { socket } = SocketState()
  let { userDetail } = AuthState()
  const [timer, setTimer] = useState(null)
  let annoucements = useSelector(SelectAnnoucements)
  let lastSaleAmount = useSelector(SelectLastSaleAmount)
  let seriesType = useSelector(SelectSeriesType)
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)
  let nextGameTime = useSelector(SelectNextGameTime)
  let currentDrawTime = useSelector(SelectCurrentGameTime)
  let lastTicketId = useSelector(SelectLastTicketId)
  let userWallet = useSelector(SelectUserWallet)
  // State for game type toggle
  const [gameType, setGameType] = React.useState('2D');

  useEffect(() => {
    let timeInterval = setInterval(() => {
      setTimer(moment().format('hh:mm:ss'))
    }, 1000);

    return () => {
      clearInterval(timeInterval)
    }
  }, [])

  // Handler for game type change
  const handleGameTypeChange = (selectedGameType) => {
    setGameType(selectedGameType);
    localStorage.setItem("gameRoute", selectedGameType)
    // Example: Navigation
    if (selectedGameType === '3D') {
      socket.emit('req', {
        en: "LOTTARY_CLOSE_GAME",
        data: {}
      });
      navigate('/3d');
    } else {
      navigate('/2d');
    }
  };
  return (
    <>
      <table width="100%" height="100%" border="0" bgcolor="#fff" style={{ fontSize: '14px' }}>
        <tbody>
          <tr>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Time To<br />
              Draw </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A0" style={{ fontSize: "24px", color: '#FF0000' }}><TimerControl /></div>
            </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Dr.Time</th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A1" style={{ fontSize: "15px", color: '#FF0000' }}>{currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('hh:mm A') : ''}</div>
            </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Id</th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A2" style={{ fontSize: "24px", color: '#FF0000' }}>{userDetail?.user_name || ''}</div>
            </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Time</th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A3" style={{ fontSize: "24px", color: '#FF0000' }}>{timer || '00:00:00'}</div>
            </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Limit</th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A4" style={{ fontSize: "24px", color: '#FF0000' }}>{userWallet || 0}</div>
            </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Last Trn </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A5" style={{ fontSize: "15px", color: '#FF0000' }}>{lastTicketId || '-'}</div>
            </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Last Pts </th>
            <th  width="5%" scope="col" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              <div id="row2A6" style={{ fontSize: "15px", color: '#FF0000' }}>{lastSaleAmount || '-'}</div>
            </th>
          </tr>
        </tbody>
      </table>
    </>
    // <div className="subHeaderContainer2d">
    //   <div className="h-1/2 container_1 flex items-center ps-2">
    //     <div className="container_1_1 clear-both">
    //       {/*  */}
    //       {/* <div className="main_gamesel_toggle float-left">
    //         <div
    //           className={`current_game_button ${gameType === '3D' ? 'active' : ''}`}
    //           onClick={(e) => {
    //             e?.preventDefault()
    //             socket.emit('req', {
    //               en: "LOTTARY_CLOSE_GAME",
    //               data: {}
    //             });
    //             // navigate("/3d");
    //             localStorage.setItem("gameRoute", "3d")
    //           }}
    //         >
    //           3D
    //         </div>
    //         <div
    //           className={`current_game_button ${gameType === '2D' ? 'active' : ''}`}
    //           onClick={() => handleGameTypeChange('2D')}
    //         >
    //           2D
    //         </div>
    //       </div> */}
    //       {/*  */}
    //       {/* <div className="checkbox_container flex items-center float-left">
    //         {['All', 'Even', 'Odd'].map((type, index) => {
    //           return (
    //             <React.Fragment key={index}>
    //               <Checkbox1
    //                 checked={seriesType === type}
    //                 id={type}
    //                 onChange={(e) => {
    //                   if (e.target.checked) {
    //                     dispatch(SET_SERIES_TYPE(type))
    //                   } else {
    //                     dispatch(SET_SERIES_TYPE('All'))
    //                   }
    //                 }}
    //                 disabled={seriesTypeDisableFlag}
    //               />{" "}
    //               <label className="checkbox_label">{type}</label>
    //             </React.Fragment>
    //           );
    //         })}

    //       </div> */}
    //       {/*  */}
    //       <div className="key_text float-left">
    //         Cur.Draw Time : <span style={{ color: "#993B3B" }}> {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('hh:mm:ss A') : ''}</span>
    //       </div>
    //       {/*  */}
    //       <div className="key_text float-left">
    //         Next Game: <span style={{ color: "#993B3B" }}> {nextGameTime}</span>
    //       </div>
    //       <div className="key_text float-left">
    //         Coupon Value:: <span style={{ color: "#993B3B" }}> 2</span>
    //       </div>
    //       <div className="key_text coin_container flex  items-center float-left">
    //         <img
    //           src="images/balance_icon.png"
    //           alt="coin"
    //           className="chip_icon"
    //         />{" "}
    //         {userWallet || 0}
    //         <img src="images/refresh-icon.svg"
    //           alt="refreshIcon"
    //           className="ml-2 w-3 cursor-pointer"
    //           onClick={() => {
    //             dispatch(SET_MAIN_LOADER(true))
    //             socket.emit('req', { "en": "WALLET_DEATILS", "data": {} }
    //             )
    //           }}
    //         />
    //       </div>
    //       <div className="container_1_2 flex float-left">
    //         <div className="secureBtn float-right cursor-pointer" onClick={() => navigate('secure')}> Secure</div>
    //         <div className="secureBtn float-right cursor-pointer" onClick={() => {
    //           localStorage.clear()
    //           socket.disconnect()

    //         }}> Logout</div>
    //       </div>
    //     </div>
    //     {/*  */}
    //     <div className="container_2_2 h-full flex items-center justify-between ps-3 pe-3">
    //       {/*  */}
    //       <div className="checkbox_container flex items-center justify-between">
    //         {['Family', 'Cross', 'Box25'].map((type, typeIndex) => {
    //           return (
    //             <React.Fragment key={typeIndex}>
    //               <Checkbox
    //                 checked={seriesType === type}
    //                 id={type}
    //                 onChange={(e) => {
    //                   if (e.target.checked) {
    //                     dispatch(SET_SERIES_TYPE(type))
    //                   } else {
    //                     dispatch(SET_SERIES_TYPE('All'))
    //                   }
    //                 }}
    //                 disabled={seriesTypeDisableFlag} />
    //               <label className="checkbox_label">{type}</label>
    //             </React.Fragment>

    //           )
    //         })}
    //       </div>

    //       <div className="advance_drawBtn" onClick={() => navigate('advance')}>Advance Draw</div>
    //       {/*  */}
    //     </div>
    //   </div>
    //   {/* <div className="h-1/2 clear-both container_2 flex">
    //     <div className="container_2_1 h-full flex items-center">
    //       <Marquee>
    //         <p className="font-bold text-[18px] mr-[100px]">{annoucements}</p>
    //         <p className="font-bold text-[18px] mr-[100px]">{annoucements}</p>
    //         <p className="font-bold text-[18px] mr-[100px]">{annoucements}</p>
    //         <p className="font-bold text-[18px] mr-[100px]">{annoucements}</p>
    //       </Marquee>
    //     </div>
    //   </div> */}
    // </div>
  );
}

export default SubHeader;
